import BoxImage from "@components/BoxImage";
import { ARTIST } from "@constants/routes";
import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { Button, ButtonToolbar, Col } from "reactstrap";
import { TArtistDto } from "types/Artist/artistDto";
import styles from "./DetailForm.module.scss";

interface IDetailForm {
  data: TArtistDto;
}

const DetailArtist = ({ data }: IDetailForm): ReactElement => (
  <form className={`${styles.detailForm} form`}>
    <Col md={3} className={styles.media}>
      <BoxImage urlImage={data?.avatarUrl} />
    </Col>

    <Col md={9}>
      <div className="form__form-group">
        <span className="form__form-group-label">Wallet Address</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.walletAddress} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Artist Name</span>
        <div className="form__form-group-field">
          <input value={data?.artistName} disabled />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">ENS Name</span>
        <div className="form__form-group-field">
          <input value={data?.ensName} disabled />
        </div>
      </div>
    </Col>

    <div className="form__form-group">
      <span className="form__form-group-label">Description</span>
      <div className="form__form-group-field">
        <textarea value={data?.description} disabled />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Categories</span>
      <div className="form__form-group-field">
        <input value={data?.category} disabled />
      </div>
    </div>

    {data?.verified && (
      <div className="form__form-group">
        <span className="form__form-group-label">Verified</span>
        <div className="form__form-group-field">
          <input value={data?.verified} disabled />
        </div>
      </div>
    )}

    <div className="form__form-group">
      <span className="form__form-group-label">Featured</span>
      <div className="form__form-group-field">
        <input value={data?.featured} disabled />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Banned</span>
      <div className="form__form-group-field">
        <input value={data?.banned} disabled />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Created At</span>
      <div className="form__form-group-field">
        <input type="text" value={data?.createdAt} disabled />
      </div>
    </div>

    <ButtonToolbar className="form__button-toolbar">
      <Link to={ARTIST}>
        <Button type="button">
          <span className="lnr lnr-chevron-left" />
          Go Back
        </Button>
      </Link>
    </ButtonToolbar>
  </form>
);

export default DetailArtist;
